import { get } from "../utils/http.util";

const BASE_URL = process.env.REACT_APP_COLLABS_API_URL ?? 'https://dev-api.degencollabs.com/v1';

export const getCommunity = async (slug: any) => {
  const url = `${BASE_URL}/communities/${slug}`
  const response = await get(url);
  return response?.payload;
};
